<template>
  <div class="filter-header">
    <el-input
      :placeholder="computedPlaceholder"
      v-model="searchVal"
      @keydown.native.enter="search"
      size="small"
      class="input-with-search"
      clearable
      @clear="search"
    >
      <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
    </el-input>
    <el-tooltip effect="dark" :content="$t('common.refresh')" placement="top">
      <div class="action-btn refresh" @click="refresh">
        <span class="iconfont icon-shuaxin-line"></span>
      </div>
    </el-tooltip>
    <el-popover
      placement="bottom-start"
      popper-class="call-pop-screen-popover"
      :width="140"
      trigger="hover"
      :visible-arrow="false"
    >
      <slot></slot>
      <div class="action-btn more" slot="reference">
        <span class="iconfont icon-gengduoheng-line"></span>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    searchPlaceholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedPlaceholder() {
      return this.searchPlaceholder || this.$t('callPopScreen.clientNamePhoneSearch')
    }
  },
  data() {
    return {
      searchVal: ''
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    },
    search() {
      this.$emit('search', this.searchVal)
    }
  }
}
</script>

<style lang="less" scoped>
.filter-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    .iconfont {
      font-size: 16px;
    }
    &.more {
      .iconfont {
        font-size: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.call-pop-screen-popover {
  padding: 0!important;
  min-width: unset!important;
  * {
    box-sizing: border-box;
  }
  .call-pop-screen-filter-options {
    padding: 4px;
    .filter-option {
      display: flex;
      align-items: center;
      width: 100%;
      height: 28px;
      padding: 0 12px;
      color: #323233;
      font-size: 12px;
      cursor: pointer;
      border-radius: 6px;
      &.active {
        background: #E6F8FF;
        color: #0090FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/filterHeader/index.vue